import React, { useEffect, useState, useContext } from "react";

import Typography from "@material-ui/core/Typography";
import { Container, Button, TextField } from "@material-ui/core";
import OwnerHeader from "./Components/OwnerHeader";
import { useLocation, useParams } from "react-router-dom";
import GlobalContext from "../../Context/globalContext";

import StorefrontIcon from "@material-ui/icons/Storefront";

import { SHOW_SNACKBAR } from "../../Context/globalActions.types";

import "jspdf-autotable";
import useSWR from "swr";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import locationOnImage from "../../assets/css/img/location-on.png";
import locationOffImage from "../../assets/css/img/location-off.png";
import locationAddImage from "../../assets/css/img/add-location.png";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Instance } from "../../Config";
import moment from "moment";
import { useMap } from "react-leaflet";

const locationOn = L.icon({
  iconUrl: locationOnImage,
  iconSize: [40, 40], // Adjust size as needed
  iconAnchor: [20, 40], // Adjust anchor as needed
  popupAnchor: [0, -40], // Adjust popup position as needed
});

const locationOff = L.icon({
  iconUrl: locationOffImage,
  iconSize: [40, 40], // Adjust size as needed
  iconAnchor: [20, 40], // Adjust anchor as needed
  popupAnchor: [0, -40], // Adjust popup position as needed
});

const locationAdd = L.icon({
  iconUrl: locationAddImage,
  iconSize: [40, 40], // Adjust size as needed
  iconAnchor: [20, 40], // Adjust anchor as needed
  popupAnchor: [0, -40], // Adjust popup position as needed
});

const FitBounds = ({ points }) => {
  const map = useMap();

  useEffect(() => {
    if (points.length > 0) {
      const bounds = L.latLngBounds(points.map((p) => [p.LAT, p.LONGI]));
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [points, map]);

  return null;
};

const OwnerViewUserLocation = () => {
  const [rows, setRows] = useState([]);
  const params = useParams();

  const { dispatch } = useContext(GlobalContext);

  const [filterSman, setFilterSman] = useState([]);
  const [formValue, setFormValue] = useState({
    smanCd: "",
    fromDate: moment().subtract(1, "month").format("YYYY-MM-DD hh:mm:ss"),
    toDate: moment().format("YYYY-MM-DD hh:mm:ss"),
  });

  const { data: resSmanFilter, error: resSmanFilterError } =
    useSWR("/location/filter");

  const shouldFetch =
    !!params.mobileNo &&
    !!formValue.smanCd &&
    !!formValue.fromDate &&
    !!formValue.toDate;
  const {
    data: resData,
    error: resDataError,
    mutate: refreshData,
    isValidating,
  } = useSWR(
    shouldFetch
      ? `/location?mobileNo=${params.mobileNo}&cd=${formValue.smanCd}&fromDate=${formValue.fromDate}&toDate=${formValue.toDate}`
      : null,
    {
      refreshInterval: 60000,
    }
  );

  const handleFromDateChange = (date) => {
    setFormValue({
      ...formValue,
      fromDate: moment(date).format("YYYY-MM-DD hh:mm:ss"),
    });
  };

  const handleToDateChange = (date) => {
    setFormValue({
      ...formValue,
      toDate: moment(date).format("YYYY-MM-DD hh:mm:ss"),
    });
  };

  useEffect(() => {
    if (resData) {
      setRows(resData.data.result);
    }
  }, [resData]);

  useEffect(() => {
    if (resSmanFilter) {
      setFilterSman(resSmanFilter.data.result);
    }
  }, [resSmanFilter]);

  useEffect(() => {
    if (resSmanFilterError || resDataError) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          message: "Something went wrong",
          type: "error",
        },
      });
    }
  }, [resSmanFilterError, resDataError]);

  const polylinePositions = rows.map((point) => [point.LAT, point.LONGI]);

  return (
    <div>
      <OwnerHeader>
        <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
          <div>
            <div className="text-indigo-500 font-semibold text-sm md:text-base">
              Store Management
            </div>
            <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
              User Location
            </div>
          </div>
        </div>
        <Container
          maxWidth="xl"
          className="pt-2 bg-[#F1F5F9] pb-5 min-h-screen"
        >
          <div>
            <div>
              <div className="mx-2 md:flex items-end gap-10 mb-4">
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="From"
                    format="DD/MM/yyyy"
                    value={formValue.fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="From"
                    value={formValue.fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                )}
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="To"
                    format="DD/MM/yyyy"
                    value={formValue.toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="To"
                    value={formValue.toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                )}
                <Autocomplete
                  id="Sman"
                  autoHighlight
                  options={filterSman}
                  getOptionLabel={(option) => option.SMAN_NAME}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.SMAN_NAME}({option.SMAN_CD})
                    </React.Fragment>
                  )}
                  className="md:w-52 w-full"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Select User"
                      margin="normal"
                    />
                  )}
                  onChange={(e, value) => {
                    console.log(value);
                    if (value) {
                      setFormValue({ ...formValue, smanCd: value.SMAN_CD });
                    }
                  }}
                />
                <br />
                {/* <Button
                  variant="contained"
                  disableElevation
                  className="mb-2 bg-[#3333cc] text-white"
                  onClick={() => {
                    setFetchData(true);
                    refreshData();
                    setFetchData(false);
                  }}
                >
                  Apply
                </Button> */}
              </div>

              {!resSmanFilter && rows.length === 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                  {["A"].map((item) => (
                    <div key={item}>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        className="h-screen w-screen"
                      />
                    </div>
                  ))}
                </div>
              ) : resSmanFilter && rows.length == 0 ? (
                <div className="min-h-screen text-center">
                  <StorefrontIcon className="text-black text-[12rem]" />
                  <Typography className="text-2xl font-bold text-black">
                    Oops!
                  </Typography>
                  <Typography>No Match Found.</Typography>
                </div>
              ) : (
                <React.Fragment>
                  <div>
                    <MapContainer
                      center={[rows[0].LAT, rows[0].LONGI]}
                      zoom={8}
                      className="h-screen w-full"
                    >
                      <FitBounds points={rows} />
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                      {/* Polyline for tracking */}
                      <Polyline
                        positions={polylinePositions}
                        color="blue"
                        weight={3}
                      />

                      {/* Markers */}
                      {rows.map((point) => (
                        <Marker
                          key={point.locId}
                          position={[point.LAT, point.LONGI]}
                          icon={
                            point.REMARK === "PUNCH_IN"
                              ? locationOn
                              : point.REMARK === "PUNCH_OUT"
                              ? locationOff
                              : point.REMARK === "PUNCH_ADD"
                              ? locationAdd
                              : locationAdd
                          }
                        >
                          <Popup>
                            {point.USER_CD.startsWith("S") ? (
                              <div>
                                <div>
                                  <span className="font-semibold">Name:</span>{" "}
                                  {point.sman.SMAN_NAME}
                                </div>
                                <div>
                                  <span className="font-semibold">Area:</span>{" "}
                                  {point.sman.SAREA}
                                </div>
                                <div>
                                  <span className="font-semibold">City:</span>{" "}
                                  {point.sman.SCITY}
                                </div>
                                <div>
                                  <span className="font-semibold">Phone:</span>{" "}
                                  {point.sman.PHN1}
                                </div>
                                {point.REMARK && (
                                  <div>
                                    <span className="font-semibold">
                                      Status:
                                    </span>{" "}
                                    {point.REMARK}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div>
                                <div>
                                  <span className="font-semibold">Name:</span>{" "}
                                  {point.account.ACC_NAME}
                                </div>
                                <div>
                                  <span className="font-semibold">Area:</span>{" "}
                                  {point.account.AREA}
                                </div>
                                <div>
                                  <span className="font-semibold">City:</span>{" "}
                                  {point.account.CITY}
                                </div>
                                <div>
                                  <span className="font-semibold">Phone:</span>{" "}
                                  {point.account.PHONE1}
                                </div>
                              </div>
                            )}
                          </Popup>
                        </Marker>
                      ))}
                    </MapContainer>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </Container>
      </OwnerHeader>
    </div>
  );
};

export default OwnerViewUserLocation;
